import i18n, { configureI18n } from '@pagopa/selfcare-common-frontend/lib/locale/locale-utils';
import it from './it';
import en from './en';
import fr from './fr';
import de from './de';
import sl from './sl';

configureI18n({ i18n, it, en, fr, de, sl });
